import uniqolor from "uniqolor"

export function getFolderTilePresentation(item, failedImage, loadedImage) {
    const accentColor = getFolderTileAccentColor(item?.label ?? "Folder")
    const hasImage = !!item?.data?.image && item.data.image !== failedImage
    if (!hasImage) {
        return {
            variant: "compact",
            accentColor,
            accentLineHeight: 6,
            buttonFlex: "0 0 auto",
            cardPaddingBottom: 0,
            contentPaddingY: 1.25,
            titleMarginTop: 0,
            transition: getTileTransition(),
        }
    }

    const imageIsLoaded = item.data.image === loadedImage
    if (!imageIsLoaded) {
        return {
            variant: "image",
            accentColor,
            accentLineHeight: 6,
            buttonFlex: "0 0 auto",
            cardPaddingBottom: 0,
            contentPaddingY: 1.25,
            imageOpacity: 0,
            titleMarginTop: 0,
            transition: getTileTransition(),
        }
    }

    return {
        variant: "image",
        accentColor,
        accentLineHeight: 180,
        buttonFlex: 1,
        cardPaddingBottom: 1,
        contentPaddingY: 0,
        imageOpacity: 1,
        titleMarginTop: 1,
        transition: getTileTransition(),
    }
}

function getFolderTileAccentColor(seed) {
    return uniqolor(seed, {
        saturation: [35, 50],
        lightness: [30, 70],
    }).color
}

function getTileTransition() {
    return "height 250ms ease, min-height 250ms ease, flex-basis 250ms ease, padding-bottom 250ms ease, margin-top 250ms ease, opacity 200ms ease"
}
